import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class NoReuseStrategy implements RouteReuseStrategy {
  shouldDetach(): boolean {
    return false;
  }

  store(): void {}

  shouldAttach(): boolean {
    return false;
  }

  retrieve(): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.data?.['noReuse'] && future.routeConfig === curr.routeConfig) {
      const futureChild = future.firstChild?.routeConfig ?? null;
      const currChild = curr.firstChild?.routeConfig ?? null;
      // Only force recreation on same-level navigation (not when a child opens/closes)
      if (futureChild === currChild) {
        return false;
      }
    }
    return future.routeConfig === curr.routeConfig;
  }
}
